import { createMemo } from 'solid-js';
import { aiLoaderTranslations as t } from 'st-app/api';
import './st-ai-loader.less'

export class STAILoaderProps {
    size: string = '300px';
    processing: boolean = true;
}

export default function STAILoader(props: { size: string, processing: boolean }) {
    const faClass = createMemo(() => props.processing ? 'fa-thin' : 'fa-solid')

    return <div classList={{"ai-animation": true,"is-processing": props.processing}} style={`--size: ${props.size}`}>
        <div class="ai-content" style="-webkit-background-clip: text">
            <div class="circle-container flexbox vertical middle">
                <span class="auto"></span>
                <div class="circle"></div>
                <span class="auto"></span>
            </div>
            <div class="text flexbox vertical middle">
                <span class="auto"></span>
                <i class={`${faClass()} fa-brain-circuit`}></i>
                <div style="text-align: center">{t.GeneratingAIContent}</div>
                <span class="auto"></span>
            </div>
        </div>
    </div>
}
STAILoader.defaultProps = new STAILoaderProps();